import script from "./x-area.vue?vue&type=script&setup=true&lang=ts"
export * from "./x-area.vue?vue&type=script&setup=true&lang=ts"

import "./x-area.vue?vue&type=style&index=0&id=6ad6ae7d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ad6ae7d"]])

export default __exports__